module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-43.2bb88fdd.svg";